import { memo } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import { IconArrowRight06 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface IProps {
  brandName: string;
  brandNameEn?: string;
  imgSrc?: string;
  priority?: boolean;
  rs?: string;
  type?: 'square' | 'round' | 'square2' | 'round2' | string;
  bgType?: 'white' | 'black' | string;
  onClick?: () => void;
}

const EvtRltdBrandItem = ({
  brandName,
  brandNameEn,
  imgSrc,
  priority,
  type = 'square',
  bgType = 'white',
  rs,
  onClick,
}: IProps) => {
  const cName = classNameBind([
    'related-brand-item item',
    `type-${type}`,
    `bg-type-${bgType}`,
  ]);

  return (
    <S.EvtRltdBrandItem className={cName}>
      <Button onClick={onClick}>
        <Img
          src={getResizeImageUrl(imgSrc, rs)}
          alt={brandName}
          priority={priority}
        />
        <div className="text-wrap">
          <Text
            weight={500}
            lineHeight="130%"
            color="#000"
            ellipsis={1}
            align={type === 'square' || type === 'square2' ? 'left' : 'center'}
            className="brand-name"
          >
            {brandName}
          </Text>
          {brandNameEn && type === 'square2' && (
            <Text
              size={12}
              lineHeight={16}
              color="#9D9D9D"
              ellipsis={1}
              className="brand-name-en"
            >
              {brandNameEn}
            </Text>
          )}
          {type === 'square' && <IconArrowRight06 />}
        </div>
      </Button>
    </S.EvtRltdBrandItem>
  );
};

export default memo(EvtRltdBrandItem);
